import { render } from "./SvgIcon.vue?vue&type=template&id=c1a4a52e"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=c1a4a52e&lang=css"

import exportComponent from "D:\\a\\r1\\a\\_av-FAI Demo Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__